import { MIDWESTBANK_NAMESPACE_ID } from "src/constants";
import { USER_ONBOARD_ADMIN, USER_ONBOARD_ADMIN_LO, USER_ONBOARD_LOAN_OFFICER, USER_ONBOARD_LOAN_OFFICER_BACK_END, USER_ONBOARD_LOAN_OFFICER_CARDS_SECURED, USER_ONBOARD_LOAN_PROCESSOR, USER_ONBOARD_UNDERWRITER } from "src/services/constants/accounts";
import SiteSettings from 'src/siteSetting';

const MIDWEST_ADMIN_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 4
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 6
    },
    {
        title: "Archived",
        key: "archived",
        order_id: 7
    },
]

const MIDWEST_ADMIN_LO_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 4
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 6
    },
    {
        title: "Archived",
        key: "archived",
        order_id: 7
    },
]

const MIDWEST_LO_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 4
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 6
    },
    {
        title: "Archived",
        key: "archived",
        order_id: 7
    },
]

const MIDWEST_LOAN_PROCESSOR_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Funded",
        key: "my_funded",
        order_id: 3
    },
    {
        title: "Archived",
        key: "archived",
        order_id: 4
    },
]

const MIDWEST_LO_BACKEND_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 4
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 6
    },
    {
        title: "Archived",
        key: "archived",
        order_id: 7
    },
]

const MIDWEST_UNDERWRITTER_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 4
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 6
    },
    {
        title: "Archived",
        key: "archived",
        order_id: 7
    },
]
export const mbwiPipelineConfig = [
    {
        namespaceId: MIDWESTBANK_NAMESPACE_ID,
        role: USER_ONBOARD_ADMIN_LO,
        tabs: MIDWEST_ADMIN_LO_TABS
    },
    {
        namespaceId: MIDWESTBANK_NAMESPACE_ID,
        role: USER_ONBOARD_ADMIN,
        tabs: MIDWEST_ADMIN_TABS
    },
    {
        namespaceId: MIDWESTBANK_NAMESPACE_ID,
        role: USER_ONBOARD_LOAN_OFFICER,
        tabs: MIDWEST_LO_TABS
    },
    {
        namespaceId: MIDWESTBANK_NAMESPACE_ID,
        role: USER_ONBOARD_LOAN_OFFICER_CARDS_SECURED,
        tabs: MIDWEST_LO_TABS
    },
    {
        namespaceId: MIDWESTBANK_NAMESPACE_ID,
        role: USER_ONBOARD_LOAN_PROCESSOR,
        tabs: MIDWEST_LOAN_PROCESSOR_TABS
    },
    {
        namespaceId: MIDWESTBANK_NAMESPACE_ID,
        role: USER_ONBOARD_LOAN_OFFICER_BACK_END,
        tabs: MIDWEST_LO_BACKEND_TABS
    },
    {
        namespaceId: MIDWESTBANK_NAMESPACE_ID,
        role: USER_ONBOARD_UNDERWRITER,
        tabs: MIDWEST_UNDERWRITTER_TABS
    }
];

